import { render, staticRenderFns } from "./actions-column.vue?vue&type=template&id=c78c0576"
import script from "./actions-column.vue?vue&type=script&lang=js"
export * from "./actions-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c78c0576')) {
      api.createRecord('c78c0576', component.options)
    } else {
      api.reload('c78c0576', component.options)
    }
    module.hot.accept("./actions-column.vue?vue&type=template&id=c78c0576", function () {
      api.rerender('c78c0576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/brand/actions-column.vue"
export default component.exports